var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetstarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7406 11.9344C15.7219 11.9188 15.6969 11.9125 15.6781 11.8969L3.625 0.987503C2.94687 0.378128 1.84687 0.378128 1.16875 0.987503C1.1625 0.993753 1.15937 1 1.15625 1.00625C0.992047 1.14183 0.859432 1.31163 0.767672 1.50379C0.675911 1.69595 0.62722 1.90582 0.624999 2.11875L0.625 23.9406C0.628504 24.1575 0.679577 24.3709 0.774614 24.5658C0.86965 24.7608 1.00633 24.9324 1.175 25.0688L1.16875 25.075C1.50995 25.3699 1.94589 25.5322 2.39687 25.5322C2.84786 25.5322 3.28379 25.3699 3.625 25.075L15.7406 14.1406C15.9002 14.0045 16.0283 13.8354 16.1162 13.6449C16.2041 13.4545 16.2496 13.2472 16.2496 13.0375C16.2496 12.8278 16.2041 12.6205 16.1162 12.4301C16.0283 12.2396 15.9002 12.0705 15.7406 11.9344Z",
    fill: "#8A3FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstarted);
export default __webpack_public_path__ + "static/media/Getstarted.185c117879899b210202d7ba588bf82c.svg";
export { ForwardRef as ReactComponent };